import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { withAbsoluteHomeRows as t } from "./rejoinHomeRows.mjs";
import { useQuery as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
//#region src/properties/useGuestHomeQuery.ts
var i = () => n({
	queryKey: e.guestHome(),
	queryFn: r.getGuestHome,
	select: t,
	staleTime: 5 * 6e4,
	refetchOnWindowFocus: !1
});
//#endregion
export { i as useGuestHomeQuery };
